import { CommandService } from '@shared/services/data/command/command.service';
import { Injectable, OnDestroy } from '@angular/core';
import { IFrameRequestHandlerI } from '../iframe-request-handler.interface';
import { mergeMap, Observable, of, ReplaySubject, Subject } from 'rxjs';
import { IFrameConversationRequest, IFrameMethod } from '@intheloop/loop-integration';
import { SmartConversationsApiService } from '@shared/modules/conversations/services/conversations-api-cache/smart-conversations-api.service';
import { ConversationModel } from '@dta/shared/models-api-loop/conversation-card/conversation/conversation.model';

@Injectable()
export class ConversationHelper implements IFrameRequestHandlerI, OnDestroy {
  readonly openDraft$: ReplaySubject<{ conversationId: string; draftCardId: string } | undefined> = new ReplaySubject<
    { conversationId: string; draftCardId: string } | undefined
  >(1);

  /**
   * The integration asks for a fresh topical chat — the widget resets its comment id and starts over.
   */
  readonly createTopicalChat$: Subject<{ integrationId: string }> = new Subject<{ integrationId: string }>();

  constructor(
    private _slashCommandService: CommandService,
    private smartConversationsApiService: SmartConversationsApiService
  ) {}

  handleRequest(request: IFrameConversationRequest, integrationId: string): Observable<any> {
    switch (request.method) {
      case IFrameMethod.RESOLVE_CONVERSATION:
        return this.resolveConversation(request.conversationId);
      case IFrameMethod.DOWNLOAD_CONVERSATION_EMLS:
        return this.downloadConversationEmls(request.conversationId);
      case IFrameMethod.DELETE_CONVERSATION:
        return this.deleteConversation(request.conversationId);
      case IFrameMethod.STAR_CONVERSATION:
        return this.starConversation(request.conversationId);
      case IFrameMethod.GET_CONVERSATION:
        return this.getConversation(request.conversationId);
      case IFrameMethod.OPEN_DRAFT_FOR_CONVERSATION:
        this.openDraft$.next({ conversationId: request.conversationId, draftCardId: request.draftCardId });
        return of(undefined);
      case IFrameMethod.CREATE_TOPICAL_CHAT:
        this.createTopicalChat$.next({ integrationId });
        return of(true);
    }
  }

  private deleteConversation(conversationId: string): Observable<any> {
    throw new Error('Method not implemented.');
  }

  private getConversation(conversationId: string): Observable<any> {
    throw new Error('Method not implemented.');
  }

  private starConversation(conversationId: string): Observable<any> {
    throw new Error('Method not implemented.');
  }

  private downloadConversationEmls(conversationId: string): Observable<any> {
    throw new Error('Method not implemented.');
  }

  private resolveConversation(conversationId: string): Observable<any> {
    return this.smartConversationsApiService.getSingle(conversationId).pipe(
      mergeMap((card: ConversationModel) => {
        return this._slashCommandService.sendCommand('/resolve', [card.cardId]);
      })
    );
  }

  ngOnDestroy(): void {
    this.openDraft$.complete();
    this.createTopicalChat$.complete();
  }
}
